var _circle, _g, _rect, _rect2, _rect3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorState = function SvgErrorState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 200,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 100,
    r: 100,
    fill: "#E6E9ED",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#error-state_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    d: "M41.5 60a2 2 0 0 1 2-2h114a2 2 0 0 1 2 2v10h-118V60Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.5 70h118v70a2 2 0 0 1-2 2h-114a2 2 0 0 1-2-2V70Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 4,
    fill: "#C9CED4",
    rx: 2,
    transform: "matrix(1 0 0 -1 93.5 114)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "#C9CED4",
    rx: 2.5,
    transform: "matrix(1 0 0 -1 85.5 102)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "#C9CED4",
    rx: 2.5,
    transform: "matrix(1 0 0 -1 110.5 102)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#E37570",
    rx: 2,
    transform: "matrix(1 0 0 -1 45.5 66)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#EFBA0F",
    rx: 2,
    transform: "matrix(1 0 0 -1 52.5 66)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#4ACC82",
    rx: 2,
    transform: "matrix(1 0 0 -1 59.5 66)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6342C",
    d: "M176.929 57.714c0 9.784-7.931 17.715-17.715 17.715-9.783 0-17.714-7.931-17.714-17.715 0-9.783 7.931-17.714 17.714-17.714 9.784 0 17.715 7.93 17.715 17.714Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M160.871 61.884h-3.413l-.717-13.68h4.847l-.717 13.68Zm-4.187 4.79c0-.88.239-1.492.717-1.836.478-.364 1.061-.545 1.749-.545.669 0 1.243.181 1.721.545.478.344.717.956.717 1.835 0 .841-.239 1.453-.717 1.836-.478.363-1.052.545-1.721.545-.688 0-1.271-.182-1.749-.545-.478-.383-.717-.995-.717-1.836Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "error-state_svg__a",
    width: 138,
    height: 104,
    x: 31.5,
    y: 56,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "effect1_dropShadow_4707_91553"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4707_91553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4707_91553",
    result: "shape"
  })))));
};
export { SvgErrorState as ReactComponent };
export default "data:image/svg+xml;base64,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";